export function IconButton({
  label,
  children,
  className = "",
  type = "button",
  ...props
}) {
  return (
    <button
      type={type}
      className={`icon-button has-tooltip${className ? ` ${className}` : ""}`}
      aria-label={label}
      {...props}
    >
      {children}
      <span className="icon-button-tooltip" aria-hidden="true">{label}</span>
    </button>
  );
}
